import './App.css'
import './styles/SearchBar.css';
import './styles/Filters.css';
import './styles/PopUp.css';
import React, { useState, useEffect } from 'react';
import SearchBar from './components/SearchBar';
import Filters from './components/Filters';
import termData from './data/termData';
import TermCard from './components/TermCard';
import TermNotFoundAlert from './components/TermNotFoundAlert';
import Header from './components/Header';
import PopUp from './components/PopUp';
import Footer from './components/Footer';
import Pagination from './components/Pagination';


function App() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedLetter, setSelectedLetter] = useState('All');
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('.footer');
      if (footer) {
        const bodyHeight = document.body.offsetHeight;
        const windowHeight = window.innerHeight;
        const footerHeight = footer.offsetHeight;

        if (bodyHeight + footerHeight < windowHeight) {
          footer.style.position = 'fixed';
          footer.style.bottom = '0';
        } else {
          footer.style.position = 'relative';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setCurrentPage(0); // Reset current page when search term changes
  };

  const handleClosePopUp = () => {
    setSelectedTerm(null);
  };

  const handleLetterSelect = (letter) => {
    setSelectedLetter(letter);

    // Reset the current page to 0 when a new filter is selected
    setCurrentPage(0) ;
  };

  const filteredTerms = termData.filter(term => {
    const startsWithSelectedLetter = selectedLetter === 'All' || term.term.toUpperCase()[0] === selectedLetter;
    const matchesSearchTerm = term.term.toLowerCase().includes(searchTerm.toLowerCase());
    return startsWithSelectedLetter && matchesSearchTerm;
  });

  // Sort the filtered terms alphabetically
  filteredTerms.sort((a, b) => a.term.localeCompare(b.term));

  // Pagination Logic
  const itemsPerPage = 5; // Adjust as needed
  const pageCount = Math.ceil(filteredTerms.length / itemsPerPage);

  const visibleTerms = filteredTerms.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <div className='App'>
      <Header />
      <div className="content" >
        <SearchBar searchTerm={searchTerm} onSearchChange={handleSearchChange} />
        <Filters onFilterSelect={handleLetterSelect} termData={termData} />
        {!visibleTerms.length && searchTerm && <TermNotFoundAlert />}
        <div className="term-card-container">
          {visibleTerms.map(term => (
            <TermCard key={term.term} term={term} setSelectedTerm={setSelectedTerm} />
          ))}
        </div>
        <Pagination pageCount={pageCount} onPageChange={handlePageChange} />
        {selectedTerm && (
          <div className="popup">
            <div className="popup-content">
              <PopUp
                term={selectedTerm.term}
                definition={selectedTerm.definition}
                origin={selectedTerm.origin}
                moreDetails={selectedTerm.moreDetails}
                category={selectedTerm.category}
                handleClosePopUp={handleClosePopUp}
              />
            </div>
          </div> 
        )}
      </div>
      <Footer />
    </div>
  );
}

export default App;
